import * as messages from "./messages";

export const getLoginErrorMessage = error => {
  let errorMessage = error.message;
  if (error.response) {
    let statusText = ""

    if (error.response.status === 403 || error.response.status === 401 || error.response.status === 400) {
      statusText = messages.wrongUsernameAndPassword
    }
    else {
      statusText = error.response.statusText
    }

    errorMessage = statusText
      ? statusText
      : messages.unknownDataAccessError;
  }
  return errorMessage;
};

export const getErrorMessage = error => {
  let errorMessage = error.message;
  if (error.response) {
    let statusText = ""

    if (error.response.status === 401) {
      statusText = messages.Unauthorized
    } else if (error.response.status === 403) {
      statusText = messages.Forbidden
    } else {
      statusText = error.response.statusText
    }

    errorMessage = statusText
      ? statusText
      : messages.unknownDataAccessError;
  } else {
    if (error.message === "Network Error") {
      errorMessage = messages.Unauthorized
    }
  }
  return errorMessage;
};
